import LazyLoad from 'vanilla-lazyload';

export default () => {

    new LazyLoad();

}